export default __webpack_public_path__ + "static/media/YAS0410.34I-29771_-17208_0.4193f799.jpg";